export const createTXT = ({
  searchType,
  selectedFilter,
  text,
  totalSearched,
  totalFound,
}: any) => {
  const date = new Date().toLocaleString();

  return `
ADVANCED SEARCH INFORMATION
==========================

Download Date:   ${date}

QUERY
-----
Search Type:     ${searchType}
Filter Type:     ${selectedFilter}
Query Text:
${text}

RESULTS SUMMARY
---------------
Total searched:  ${totalSearched}
Total found:     ${totalFound}

==========================
`;
};
